module.exports = __webpack_public_path__ + "img/ico_ugc_txt_long_on.6da8280.svg";